import 'css-chunk:src/index/pages/task_list/index.module.scss';export default {
  "tablet": "tablet__06Zy5",
  "sp": "sp__lp-ex",
  "pc": "pc__2QkSo",
  "pcTablet": "pcTablet__THMuo",
  "section": "section__-klt-",
  "relative": "relative__0HD-A",
  "row": "row__iP4ov",
  "middle": "middle__jIAwl",
  "formLabel": "formLabel__JkGDV",
  "formLabel2": "formLabel2__Pvv1L",
  "formLabelIssue": "formLabelIssue__7F93y",
  "alert": "alert__-Jkxg",
  "show": "show__mHL9p",
  "searchBoxSection": "searchBoxSection__rUjso",
  "menuShowBtn": "menuShowBtn__6LHZt",
  "infoBox": "infoBox__a7dgf",
  "conflictBox": "conflictBox__jDSoP",
  "searchBox": "searchBox__tMrAS",
  "hide": "hide__7nARY",
  "sectionChk": "sectionChk__Z-zCe",
  "sectionChkText": "sectionChkText__iqAcX"
};